import { QueryOrderSettings, QueryOrderDirection } from '@sprinx/query-builder';
import { textContainsToQuery } from '@sprinx/query-builder';

export function getOrderCallParam(urlSearch: Record<string, string>): QueryOrderSettings | undefined {
  const searchParams = new URLSearchParams(urlSearch);
  const orderBy = searchParams.get('orderBy');
  const orderDirection = (searchParams.get('orderByDirection') as QueryOrderDirection) || 'asc';

  if (!orderBy) return undefined;

  return {
    orderBy,
    orderDirection,
  };
}

export function getSearchCallParam(urlSearch: Record<string, string>, locale: string) {
  const searchParams = new URLSearchParams(urlSearch);
  const search = searchParams.get('search');

  if (!search) return undefined;

  return {
    field: 'globalSearchText',
    operator: 'contains',
    value: search,
    toQuery: (v: string) => textContainsToQuery(`_all.${locale}`, v),
  };
}

export function getSkuCallParam(urlSearch: Record<string, string>) {
  const searchParams = new URLSearchParams(urlSearch);
  const sku = searchParams.get('skus');

  if (!sku) return undefined;

  return {
    field: 'skuList',
    operator: 'in',
    value: sku,
    toQuery: (v: string) => ({
      sku: {
        $in: v
          .split(';')
          .map((s) => s.trim().toUpperCase())
          .filter(Boolean),
      },
    }),
  };
}
